<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="bg-img-hero">
        <!-- <img class="bgImgs" src="@/assets/svg/components/abstract-shapes-12.svg" alt="" /> -->
        <div class="container space-top-2 space-bottom-2 position-relative z-index-2">
          <div class="w-md-80 w-lg-60 text-center mx-md-auto">
            <h1>常见问题</h1>
            <p>
              我们列出了用户提出的一些常见问题并予以解答，您可查看是否对您有帮助。
            </p>
          </div>
        </div>
      </div>
      <!-- End Hero Section -->

      <!-- FAQ Topics Section -->
      <div class="container space-2 space-bottom-lg-3">
        <div class="row justify-content-lg-center">
          <div class="col-lg-8">
            <div id="basics" class="space-bottom-1">
              <h2>关于创联天成</h2>

              <!-- Basics Accordion -->
              <div id="basicsAccordion">
                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="basicsHeadingOne">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#basicsCollapseOne" aria-expanded="false" aria-controls="basicsCollapseOne">
                      创联天成是一家什么样的公司？

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="basicsCollapseOne" class="collapse" aria-labelledby="basicsHeadingOne" data-parent="#basicsAccordion">
                    <div class="card-body px-0">
                      <p>
                        创联天成是一家基于系统集成的数据可视化公司。为客户提供融合创新，面向未来的数字可视化服务，助力新基建智能升级。我们为企业信息化业务发展提供增长动力，将技术优势内化到产品中，提供更贴心、更智慧、更灵活的服务。
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="basicsHeadingTwo">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#basicsCollapseTwo" aria-expanded="false" aria-controls="basicsCollapseTwo">
                      创联天成能够为您解决哪些问题（或者说您需要我们提供哪些服务）

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="basicsCollapseTwo" class="collapse" aria-labelledby="basicsHeadingTwo" data-parent="#basicsAccordion">
                    <div class="card-body px-0">
                      <p>
                        创联天成致力于面向企业的信息化、智能化、新基建转型创新的定制类产品研发，以及面向公众的个性化互联网服务。广泛运用3D、XR、JAVA等互联网前沿技术和云资源，围绕企业大数据分析与展示、数据可视化设计与呈现、物联网信息采集与管控、DICT集成与运维、工业互联网应用与推广等专业领域，基于客户业务数据和逻辑，为客户提供适配手机、PAD、PC、大屏、专业设备等多类型终端的智能平台建设与软硬件整体解决方案。
                      </p>
                      <p>
                        同时我们还乐于为您提供，APP及行业软件，游戏及动画人物，三维建模等软件开发和设计服务。
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="basicsHeadingThree">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#basicsCollapseThree" aria-expanded="false" aria-controls="basicsCollapseThree">
                      有项目，需要技术（软件/硬件）支撑！

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="basicsCollapseThree" class="collapse" aria-labelledby="basicsHeadingThree" data-parent="#basicsAccordion">
                    <div class="card-body px-0">
                      <p>
                        创联天成拥有良好和丰富的合作生态，可为您解决系统集成及软件开发中遇到的众多问题。如果您有优质且可执行的项目，我们欢迎您与我们的商务经理取的联系，双方可洽谈多元的合作方式。
                      </p>
                      <p>
                        我们的联系方式：太原市小店区北美N1文创区8号楼604室
                        联系电话：（0351）8788808 商务经理：安经理 17635185888
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="basicsHeadingFour">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#basicsCollapseFour" aria-expanded="false" aria-controls="basicsCollapseFour">
                      有资金，是否可以进行商业合作？

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="basicsCollapseFour" class="collapse" aria-labelledby="basicsHeadingFour" data-parent="#basicsAccordion">
                    <div class="card-body px-0">
                      <p>不可以，我们还在等待机会。</p>
                      <p>
                        目前我们还在开发和完善软件,
                        不能够为您提供稳定的收益保障。如果您对可视化项目软件感兴趣，可以和商务经理索取资料，期待以后合作。
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->
              </div>
              <!-- End Basics Accordion -->
            </div>

            <div id="syncing" class="space-1">
              <h2>关于数据可视化</h2>

              <!-- Syncing Accordion -->
              <div id="syncingAccordion">
                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="syncingHeadingOne">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#syncingCollapseOne" aria-expanded="false" aria-controls="syncingCollapseOne">
                      什么是数据可视化？

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="syncingCollapseOne" class="collapse" aria-labelledby="syncingHeadingOne" data-parent="#syncingAccordion">
                    <div class="card-body px-0">
                      <p>
                        数据可视化使用数据图表的方式来分析并展示庞杂数据的产品，通过易读、易懂、易操作的图表，给用户带来良好的视觉效果，降低用户的理解难度，并借此传达信息。
                      </p>
                      <p>
                        目前，无论在零售、物流、电力、水利、环保、还是交通领域，通过交互式实时数据可视化大屏来帮助决策人员发现并诊断业务问题，越来越成为大数据解决方案中的重要环节。
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="syncingHeadingTwo">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#syncingCollapseTwo" aria-expanded="false" aria-controls="syncingCollapseTwo">
                      创联天成的数据可视化服务能够解决什么问题？

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="syncingCollapseTwo" class="collapse" aria-labelledby="syncingHeadingTwo" data-parent="#syncingAccordion">
                    <div class="card-body px-0">
                      <li>
                        对于数据可视化参观，用硬件设备有冲击力的显示表现内容，留下生动，深刻的印象
                      </li>
                      <li>
                        对于传统报表数据类型（如时空数据、关系数据）的分析展现，构建复杂的关系面板
                      </li>
                      <li>
                        对动画，视觉特效，行为等呈现工作原理，流程状态的展示和交互
                      </li>
                      <li>
                        对从大数据挖掘，到经营，运营等后台数据的多角度表现，帮助决策者作出重要判断提供数据支撑
                      </li>
                      <li>
                        对视频监控，音频监控等实时数据进行调用，同时结合数据库进行分析研判
                      </li>
                      <li>
                        对工业互联网提供产品制造全生命周期的数据监测，进行分析挖掘实现高效决策和反馈
                      </li>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="syncingHeadingThree">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#syncingCollapseThree" aria-expanded="false" aria-controls="syncingCollapseThree">
                      解决企业数据可视化需要多少钱？

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="syncingCollapseThree" class="collapse" aria-labelledby="syncingHeadingThree" data-parent="#syncingAccordion">
                    <div class="card-body px-0">
                      <p>
                        我们提供给客户的软件产品大约相当于主流可视化产品的二分之一，并授予充分的客户自主研发知识版权。让您能够预留有充足的预算采购更高规格的产品及定制内容。
                      </p>
                      <p>
                        同时我们为客户提供整套解决方案，包含（效果图-装修-硬件部署-软件部署-维护）的全生命周期服务，让客户能够最低成本的实现数据可视化项目部署。
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->
              </div>
              <!-- End Syncing Accordion -->
            </div>

            <div id="account" class="space-1">
              <h2>关于系统集成</h2>

              <!-- Account Accordion -->
              <div id="accountAccordion">
                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="accountHeadingOne">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#accountCollapseOne" aria-expanded="false" aria-controls="accountCollapseOne">
                      什么是系统集成?

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="accountCollapseOne" class="collapse" aria-labelledby="accountHeadingOne" data-parent="#accountAccordion">
                    <div class="card-body px-0">
                      <p>
                        系统集成( system
                        integration)通常是指将软件、硬件与通信技术组合起来为用户解决信息处理问题的业务，集成的各个分离部分原本就是一个个独立的系统，集成后的整体的各部分之间能彼此有机地和协调地工作，以发挥整体效益，达到整体优化的目的。
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="accountHeadingTwo">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#accountCollapseTwo" aria-expanded="false" aria-controls="accountCollapseTwo">
                      创联天成的系统集成服务能够解决什么问题?

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="accountCollapseTwo" class="collapse" aria-labelledby="accountHeadingTwo" data-parent="#accountAccordion">
                    <div class="card-body px-0">
                      <p>
                        创联天成拥有多项系统集成企业资质。同时，创联天成是中移铁通，山西联通，山西移动，（山西电信洽谈中）的ICT合作伙伴，拥有丰富的系统集成经验。
                      </p>
                      <p>
                        基于目前移动互联网、物联网和新基建、5G的应用大环境，我们着重于为客户提供与运营商合作的系统集成服务，我们热忱欢迎有资金实力或相关业务的合作伙伴与我们取得联系。
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="accountHeadingThree">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#accountCollapseThree" aria-expanded="false" aria-controls="accountCollapseThree">
                      系统集成软件合作/开发的模式和费用是多少?

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="accountCollapseThree" class="collapse" aria-labelledby="accountHeadingThree" data-parent="#accountAccordion">
                    <div class="card-body px-0">
                      <p>请与商务经理取得联系详洽</p>
                      <p>
                        我们的联系方式：太原市小店区北美N1文创区8号楼604室
                        联系电话：（0351）8788808 商务经理：安经理 17635185888
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->

                <!-- Card -->
                <div class="card shadow-none mb-3">
                  <div class="card-header card-collapse" id="accountHeadingFour">
                    <a class="btn btn-link btn-block d-flex justify-content-between card-btn collapsed bg-white px-0" href="javascript:;" role="button" data-toggle="collapse" data-target="#accountCollapseFour" aria-expanded="false" aria-controls="accountCollapseFour">
                      系统集成硬件合作/开发的模式和费用是多少?

                      <span class="card-btn-toggle">
                        <span class="card-btn-toggle-default">&plus;</span>
                        <span class="card-btn-toggle-active">&minus;</span>
                      </span>
                    </a>
                  </div>
                  <div id="accountCollapseFour" class="collapse" aria-labelledby="accountHeadingFour" data-parent="#accountAccordion">
                    <div class="card-body px-0">
                      <p>请与商务经理取得联系详洽</p>
                      <p>
                        我们的联系方式：太原市小店区北美N1文创区8号楼604室
                        联系电话：（0351）8788808 商务经理：安经理 17635185888
                      </p>
                    </div>
                  </div>
                </div>
                <!-- End Card -->
              </div>
              <!-- End Account Accordion -->
            </div>
          </div>
        </div>
      </div>
      <!-- End FAQ Topics Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3
export default {
  components: {
    Header,
    Footer,
  },
  mounted() {
    $(document).ready(function () {
      // initialization of header
      // var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of show animations
      $(".js-animation-link").each(function () {
        var showAnimation = new HSShowAnimation($(this)).init();
      });

      // initialization of form validation
      $(".js-validate").each(function () {
        $.HSCore.components.HSValidation.init($(this), {
          rules: {
            confirmPassword: {
              equalTo: "#signupPassword",
            },
          },
        });
      });

      // initialization of dropzone
      $(".js-dropzone").each(function () {
        var dropzone = $.HSCore.components.HSDropzone.init(
          "#" + $(this).attr("id")
        );
      });

      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
    });
  },
};
</script>

<style scoped>
.bg-img-hero {
  background: #f8f9fb;
}
.mx-md-auto h1 {
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.mx-md-auto p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.space-bottom-1 h2,
.space-1 h2 {
  margin-bottom: 0.5rem;
  font-size: 1.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.card-btn {
  color: #1e2022;
  text-align: left;
  white-space: inherit;
}
.btn-link {
  font-weight: 600;
  text-decoration: none;
}
.card-body p,
.card-body li {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
  padding: 0 20px;
}
.mb-3 {
  border: none;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>


// WEBPACK FOOTER //
// src/view/question.vue